async function convertBlobToJson(blob: Blob) {
	try {
		const response = new Response(blob)
		const jsonObject = await response.json()
		return jsonObject
	} catch (error) {}
	return null
}

const toastErrors = async (e: any) => {
	const { $i18n, $toast } = useNuxtApp()
	const error = (text: string) => {
		$toast.error({ message: text })
	}
	if (typeof e == "string") {
		error(e)
		return
	}
	try {
		if (e.response._data instanceof Blob) {
			e.response._data = await convertBlobToJson(e.response._data)
		} else if (e.data instanceof Blob) {
			e.data = await convertBlobToJson(e.response._data)
		}
	} catch (_) {
		e.message = $i18n.t("something_went_wrong")
	}
	if (!e.response && !e.data) {
		if (!e.message || e.message === "") error($i18n.t("something_went_wrong") as string)
		else error(e.message)
	} else if (!Object.keys(e.response?._data?.errors || e.data?.errors || {})?.length) {
		if (e.response?._data?.message) {
			error(e.response?._data?.message)
		} else if (!e.response?.statusText || e.response?.statusText === "") error($i18n.t("something_went_wrong"))
		else if (e.response?.status === 403) {
			error($i18n.t("something_went_wrong"))
		} else error(e.response?.statusText)
	} else {
		Object.values(e.response?._data?.errors || e?.data?.errors).forEach((i: any) => {
			Object.values(i).forEach((t: any) => {
				error(t)
			})
		})
	}
}

export default toastErrors
